import React, { FC, useEffect, useState }               from "react";
import { useDispatch }                                  from "react-redux";
import { Button, Message, Modal, TransitionablePortal } from "semantic-ui-react";
import { ApiClient }                                    from "../../../infrastructure/configure/ApiClientConfig";
import RouterDispatcher                                 from "../../../infrastructure/redux/router/RouterDispatcher";

const ContractPeriodInformation: FC = () => {
  const [expired, setExpired] = useState(false);
  const [expiredTwoWeek, setExpiredTwoWeek] = useState(false);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  useEffect(() => {
    ApiClient.get("/corporation/contract/expired")
      .then(response => {
        if (response.data) {
          setExpired(response.data);
        } else {
          ApiClient.get("/corporation/contract/expired/twoweek")
            .then(response => {
              if (response.data) {
                setExpiredTwoWeek(response.data);
              }
            })
        }
      })
  }, []);

  return (
    <>
      <TransitionablePortal
        open={ expiredTwoWeek }
        transition={ {animation: "scale"} }
      >
        <Message
          floating
          warning
          style={ {left: "0", bottom: "1rem", position: "fixed", zIndex: 1000} }
        >
          <Message.Header>まもなくお試し期間が終了します。</Message.Header>
          <p>お試し期間終了後も引き続きご利用になる場合は決済情報を入力してください。</p>
          <Button
            primary
            onClick={ () => routerDispatcher.paymentRegister() }
          >
            決済情報を入力する
          </Button>
        </Message>
      </TransitionablePortal>

      <Modal
        open={ expired }
      >
        <Modal.Header>お試し期間が終了しました。</Modal.Header>
        <Modal.Content>
          <p>引き続きResKaをご利用になる場合は決済情報を入力してください。</p>
          <Modal.Description>
            <Button
              primary
              onClick={ () => routerDispatcher.paymentRegister() }
            >
              決済情報を入力する
            </Button>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={ () => window.location.href = "/logout" }
          >
            ログアウト
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ContractPeriodInformation;
